// modal-template-login.js
import axios from 'axios';

const classPrefix = 'modal-template-login';
const dataPrefix = 'data-modal-template-login';
import { input } from '../../input/input';
export function modalTemplateLogin($container) {
    const $template = document.querySelector(`[${dataPrefix}-template]`)

    init();
    function init(){
        const $modalClone = document.importNode($template.content, true)

        const $form = $modalClone.querySelector(`[${dataPrefix}-form]`);
        const $restore = $modalClone.querySelector(`[${dataPrefix}-restore]`);
        const $confirm = $modalClone.querySelector(`[${dataPrefix}-confirm]`);

        renderFields($form)
        ensureStatusField($form);
        $confirm.addEventListener('click', () => {
            submitLogin($form, $confirm);
        });

        if ($restore) {
            $restore.addEventListener('click', () => {
                console.log('restore click');
            });
        }


        $container.appendChild($modalClone)
    }
    function renderFields($form) {
        // очищаем от предыдущих
        $form.innerHTML = '';

        input($form, {
            type: 'email',
            label: 'Email',
            name: 'email',
            autocomplete: 'email',
            required: true,
        });

        input($form, {
            type: 'password',
            label: "Пароль",
            name: 'password',
            autocomplete: 'current-password',
            required: true,
        });
    }

    function ensureStatusField($form) {
        // общий статус/ошибка
        let $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) {
            $status = document.createElement('div');
            $status.className = `${classPrefix}__status`;
            $form.appendChild($status);
        }
    }

    function setStatusMessage($form, message, isError = true) {
        const $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) return;
        $status.textContent = message || '';
        $status.style.display = message ? 'block' : 'none';
        $status.classList.toggle('is-error', isError);
    }

    function clearErrors($form) {
        // удаляем старые текстовые сообщения ошибок под input'ами
        $form.querySelectorAll(`.${classPrefix}__field-error`).forEach(e => e.remove());
        setStatusMessage($form, '');
        // сброс состояния инпутов
        $form.querySelectorAll('input, textarea').forEach(el => {
            el.classList.remove('is-invalid');
        });
    }

    function showFieldError($input, message) {
        $input.classList.add('is-invalid');
        // создаём или обновляем элемент ошибки под полем
        let $err = $input.parentNode.querySelector(`. ${classPrefix}__field-error`);
        // у родителя может быть нет класса, просто ищем уже существующий
        $err = $input.parentNode.querySelector('.' + classPrefix + '__field-error');
        if (!$err) {
            $err = document.createElement('div');
            $err.className = classPrefix + '__field-error';
            $input.parentNode.appendChild($err);
        }
        $err.textContent = message;
    }

    // главная функция отправки
    async function submitLogin($form, $confirmBtn) {
        clearErrors($form);
        setStatusMessage($form, '');

        // собираем поля по имени
        const payload = {};
        $form.querySelectorAll('input[name], textarea[name]').forEach(($el) => {
            const name = $el.getAttribute('name');
            // для чекбоксов/радио можно добавить ветку, но здесь простые поля
            payload[name] = $el.value;
        });

        // UI: блокируем кнопку
        const oldBtnText = $confirmBtn.textContent;
        $confirmBtn.setAttribute('disabled', 'true');
        $confirmBtn.classList.add('is-loading');
        $confirmBtn.textContent = 'Входим...';

        // Настройки axios для laravel
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['Accept'] = 'application/json';

        // CSRF: попробуем прочитать meta-tag, если он есть
        const metaToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (metaToken) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = metaToken;
        }
        // Если вы используете cookie XSRF-TOKEN (Laravel), axios автоматически отправит cookie при запросах,
        // но если нужна явная инициализация для Sanctum: axios.get('/sanctum/csrf-cookie')

        try {
            // Подмените URL на ваш роут логина, если он другой
            const response = await axios.post('/login', payload);

            // Успех: сервер может вернуть redirect URL или просто 200
            // Примеры: response.data.redirect || response.request.responseURL || reload
            const redirectTo = response.data?.redirect || response.data?.url;
            if (redirectTo) {
                window.location.href = redirectTo;
                return;
            }

            // Если сервер вернул 200 и хочет просто обновить страницу
            window.location.reload();

        } catch (error) {
            setStatusMessage($form, error.response.data.message, true);
            console.error(error);
        } finally {
            // разблокируем кнопку
            $confirmBtn.removeAttribute('disabled');
            $confirmBtn.classList.remove('is-loading');
            $confirmBtn.textContent = oldBtnText;
        }
    }
}
